
















import { Prop, Component, Vue } from "vue-property-decorator";
import Action from "@/models/action";

@Component({})
export default class VToolbar extends Vue {
  @Prop({ default: () => [] }) actions!: Action[];
}
